module.exports = __webpack_public_path__ + "static/media/purchase_glossary_cards.fb7dfe1d.png";